import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AuthAccessTokenDetails,
  OauthAEMConfig,
  TokenService,
  UserDataService
} from '@com-delta-idp/mnx-oauth';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APPS
} from '@com-delta-idp/mnx-utils';
import { from, Observable, of } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
import {
  DEFAULT_TIMEOUT,
  HTTP_HEADERS,
  MyTripEndpointKeys,
  SHARED_UPCOMING_TRIP
} from '../../model/enums/most-upcoming-trips.enums';
import { TodaysTrip } from '../../model/today-trip.model';

@Injectable({
  providedIn: 'root'
})
export class TodaysTripAwsService {
  todaysTrip$!: Observable<TodaysTrip>;
  headerInfo: HttpHeadersPayload = {
    'Content-Type': 'application/json; charset=UTF-8',
    Authorization: ''
  };

  constructor(
    private tokenService: TokenService,
    private appConfigService: AppConfigService,
    private userDataService: UserDataService,
    private http: HttpClient
  ) {}

  _errorHandler = handleError.bind(this);

  getTodayTrip = (skymilesNumber: string): Observable<TodaysTrip> => {
    if (this.todaysTrip$) {
      return this.todaysTrip$;
    } else {
      this.todaysTrip$ = this.initAwsAPI(skymilesNumber).pipe(shareReplay());
      return this.todaysTrip$;
    }
  };

  initAwsAPI(skymilesNumber: string): Observable<TodaysTrip> {
    return this.userDataService.getAuthConfigContent().pipe(
      switchMap((authConfig: OauthAEMConfig) => {
        authConfig.SCOPE_VALUE_RM = `${authConfig.SCOPE_VALUE} ${authConfig.SAVED_SEARCH_GRAPHQL_SCOPE_VALUE}`;
        authConfig.CLIENT_ID_VALUE = `${authConfig.HEADER_CLIENT_ID_VALUE}`;
        return from(this.tokenService.getAccessToken(authConfig)).pipe(
          switchMap((token: AuthAccessTokenDetails) => {
            this.headerInfo[
              'Authorization'
            ] = `${HTTP_HEADERS.BEARER} ${token.access_token}`;

            const payload = new URLSearchParams({
              skymilesNbr: skymilesNumber,
              nmbrOfTrips: '1',
              transactionId: `${HTTP_HEADERS.TODAYS_TRIP} ${uuid()}`
            }).toString();

            return new ApiBuilder<string, TodaysTrip>(
              this.http,
              this.appConfigService
            )
              .app(IDP_APPS.HEADER)
              .endpointKey(MyTripEndpointKeys.GET_TODAYS_TRIP_AWS_URL)
              .method(HttpRequestMethods.POST)
              .payload(payload)
              .httpHeaders(this.headerInfo)
              .errorHandler(this._errorHandler)
              .timeOut(DEFAULT_TIMEOUT)
              .library(SHARED_UPCOMING_TRIP)
              .create();
          })
        );
      })
    );
  }
}
